/**
 * @prop --color: Color of section
 * @prop --background-color: Background color of section
 */

:host {
  --color: #{$colorBlack};
  --answer-color: var(--stzh-saptcha-answer-color, #{$colorPrimary});
  --background-color: #{$colorGrey10};
}

.stzh-saptcha {
  &__box {
    @include spaceCurve("padding-top", "regular");
    @include spaceCurve("padding-bottom", "medium");
    padding-left: space("medium");
    padding-right: space("medium");
    color: var(--color);
    background-color: var(--background-color);

    @include mq($from: medium) {
      padding-left: space("large");
      padding-right: space("large");
    }
  }

  &__info {
    @include fontSize("milli");
  }

  &__answer {
    @include fontSize("regular");
    color: var(--answer-color);
    margin-top: space("xsmall");
  }

  &__input {
    margin-top: space("medium");
  }
}
